import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  getCurrentValueInPixels(value = 4.75): number {
    const rootFontSize = Number.parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    return Number.parseFloat((value * rootFontSize).toFixed(2));
  }

  sumArray(arr: number[]): number {
    const sum = arr.reduce((acc, cur) => +acc + +cur, 0);
    return Number.isInteger(sum) ? sum : Number.parseFloat(sum.toFixed(2));
  }

  formatPercentage(value: number | string, total: number | string): number {
    if (Number(total) === 0 || Number.isNaN(Number(total))) return 0;
    if (Number.isNaN(Number(value))) return 0;
    return Number.parseFloat(((Number(value) / Number(total)) * 100).toFixed());
  }
}
